import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["planSelect", "memberCountInput", "billingCycleWrapper"]
  static values = {
    currentMembers: { type: Number, default: 50 }
  }

  connect() {
    console.log("Connedted ");

    this.updateMemberCount()
    this.toggleBillingCycle()    
  }

  updateMemberCount() {
    console.log(12323);

    const plan = this.planSelectTarget.value
    const input = this.memberCountInputTarget
    
    // Set member count based on plan
    switch(plan) {
      case 'free':
        input.value = 50
        break
      case 'medium':
        input.value = 100
        break
      case 'large':
        input.value = Math.max(this.currentMembersValue, 120)
        break
      default:
        input.value = this.currentMembersValue
    }
  }

  toggleBillingCycle() {
    if (!this.hasBillingCycleWrapperTarget) return
    
    const plan = this.planSelectTarget.value
    const wrapper = this.billingCycleWrapperTarget
    
    // Hide billing cycle for free plan (not needed, never expires)
    if (plan === 'free') {
      wrapper.style.display = 'none'
    } else {
      wrapper.style.display = ''
    }
  }
}
